export default {
  names: {
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    newEmail: 'Neue E-Mail',
    confirmEmail: 'Neue E-Mail bestätigen',
    newPassword: 'Neues Passwort'
  }
}
